<template>
<div>
  <!-- PASO 1 -->
  <modal :show.sync="showModal" size="lg" ref="m0d41">
    <h6 slot="header" class="modal-title">Formulario Denuncia de Siniestro</h6>
    <h6 class="mb-3">Fecha denuncia: 20-01-2020</h6>
    <div class="form-row">
        <div class="col-md-6">
            <collapse :active-index="1">
                <collapse-item name="1">
                    <h5 slot="title" class="mb-0">Datos Generales</h5>
                    <div>
                        <h4>Nombre Plan</h4>
                        <span>{{nombre_plan}}</span>
                        <h4>Estado certificado</h4>
                        <span>{{estado}}</span>
                    </div>
                </collapse-item>
                <collapse-item name="2">
                    <h5 slot="title" class="mb-0">Antecedentes de la compra</h5>
                    <div>
                        <h4>Fecha compra</h4>
                        <span>{{fecha_compra}}</span>
                        <h4>Monto asegurado</h4>
                        <span>{{monto_asegurado}}</span>
                    </div>
                </collapse-item>
                <collapse-item name="3">
                    <h5 slot="title" class="mb-0">Antecedentes de la Materia Asegurada</h5>
                    <div class="mt-2 mb-2" v-for="(atributo,index) in materia_asegurada.campos_venta" :key="index">
                        <h4>{{atributo.nombre}}</h4>
                        <span>{{atributo.valor}}</span>
                    </div>
                </collapse-item>
                <collapse-item name="4">
                    <h5 slot="title" class="mb-0">Antecedentes del Asegurado</h5>
                    <div>
                        <h4>Nombre</h4>
                        <span>{{asegurado.nombre}}</span>
                        <h4>Rut</h4>
                        <span>{{asegurado.dni}}</span>
                        <h4>Direccion</h4>
                        <span>{{asegurado.direccion}}</span>
                        <h4>Teléfono</h4>
                        <span>{{asegurado.telefono}}</span>
                        <h4>Correo</h4>
                        <span>{{asegurado.email}}</span>
                        <h4>Ciudad</h4>
                        <span>{{asegurado.ciudad}}</span>
                        <h4>Celular</h4>
                        <span>{{asegurado.celular}}</span>
                    </div>
                </collapse-item>
            </collapse>
        </div>
        <div class="col-md-6">
            <h5>Completa los datos del formulario</h5>
            <div class="form-row ml-1" v-for="(campo,index) in materia_asegurada.campos_siniestro" :key="index">
                <div class="col-md-12">
                    <base-input :label="campo.nombre" 
                                :placeholder="'Ingrese un valor para '+campo.nombre" 
                                v-model="campos_siniestro[index].valor"
                                :name="campo.nombre"
                                :error="getError(campo.nombre)"
                                v-validate="'required'"
                                >
                    </base-input>
                </div>
            </div>
            <div class="form-row ml-1">
                <div class="col-md-12">
                    <base-input addon-left-icon="ni ni-calendar-grid-58" label="Fecha de siniestro:"
                                name="Fecha siniestro"
                                :error="getError('Fecha siniestro')"
                                v-validate="'required|date_format:dd-MM-yyyy'"
                                v-model="fecha"
                    >
                        <flat-picker slot-scope="{focus, blur}"
                                    @on-open="focus"
                                    @on-close="blur"
                                    :config="config"
                                    placeholder="Ingrese fecha de siniestro"
                                    class="form-control datepicker"
                                    v-model="fecha">
                        </flat-picker>
                    </base-input>
                </div>
            </div>
            <div class="form-row ml-1">
                <div class="col-md-12">
                    <base-input label="Tipo de siniestro"
                                :name="'Tipo de siniestro'"
                                :error="getError('Tipo de siniestro')"
                                v-validate="'required'"
                                v-model="model.tipo_siniestro"
                    >
                        <el-select clearable v-model="model.tipo_siniestro" filterable
                                    placeholder="Seleccione tipo de siniestro">
                            <el-option v-for="option in selectTipoSiniestro"
                                        :key="option.label"
                                        :label="option.label"
                                        :value="option.value">
                            </el-option>
                        </el-select>
                    </base-input>
                </div>
            </div>
            <div class="form-row ml-1">
                <div class="col-md-12">
                    <base-input label="Lugar de Ocurrencia" 
                                placeholder="Ingrese la dirección" 
                                v-model="lugar"
                                :name="'Lugar de ocurrencia'"
                                :error="getError('Lugar de ocurrencia')"
                                v-validate="'required'"
                                >
                    </base-input>
                </div>
            </div>
            <div class="form-row ml-1" v-show="sponsor.pais == 'Chile'">
                <div class="col-md-12">
                    <base-input label="Región:"
                                :name="'Región'"
                                :error="getError('Región')"
                                v-validate="''"
                                v-model="region"
                    >
                        <el-select   @change="updateComunas" v-model="region" filterable
                                    placeholder="Seleccione región:"
                                    
                                    >
                            <el-option v-for="option in dataRegiones"
                                        :key="option.region"
                                        :label="option.region"
                                        :value="option.region">
                            </el-option>
                        </el-select>
                    </base-input>
                </div>
            </div>
            <div class="form-row ml-1" v-show="sponsor.pais == 'Chile'">
                <div class="col-md-12">
                    <base-input label="Comuna:"
                                :name="'Comuna'"
                                :error="getError('Comuna')"
                                v-validate="''"
                                v-model="comuna"
                    >
                        <el-select  v-model="comuna" filterable
                                    placeholder="Seleccione comuna:"
                                    
                                    >
                            <el-option v-for="option in comunasList"
                                        :key="option"
                                        :label="option"
                                        :value="option">
                            </el-option>
                        </el-select>
                    </base-input>
                </div>
            </div>
            <div class="form-row ml-1">
                <div class="col-md-12">
                    <base-input v-model="ciudad" 
                                label="Ciudad:" 
                                placeholder="Ingrese la ciudad"
                                :name="'Ciudad'"
                                :error="getError('Ciudad')"
                                v-validate="'required'"
                                >
                    </base-input>
                </div>
            </div>
            <div class="form-row ml-1">
                <div class="col-md-12">
                    <base-input label="Relato de los hechos:"
                                v-model="relato"
                                :name="'Relato de los hechos'"
                                :error="getError('Relato de los hechos')"
                                v-validate="'required'"
                                >
                        <textarea v-model="relato" 
                                  class="form-control form-control-alternative" 
                                  rows="3" 
                                  placeholder=""
                                  
                        ></textarea>
                    </base-input>
                </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <!--<base-button type="warning" @click="$emit('openModalFirmarFormulario', venta_id)">Ingresar firma</base-button>-->
              </div>
            </div>
        </div>
    </div>
    <template slot="footer">
      <!--
      <el-tooltip content="Debes ingresar la firma para confirmar" placement="top" v-if="!tieneFirma">
        <base-button type="primary" @click="sendForm" :disabled="!tieneFirma" >Confirmar</base-button>
      </el-tooltip>
      <base-button type="primary" @click="sendForm"  v-if="tieneFirma" >Confirmar</base-button>
      -->
      <base-button type="primary" @click="sendForm"  >Confirmar</base-button>
      <base-button type="link" class="ml-auto" @click="showModal = false">Cancelar</base-button>
    </template>

  </modal>
  <firmar-formulario @firmaSuccess="fetchData(venta_id)" @modalClosed="reiniciarOverflow"></firmar-formulario>
</div>
</template>
<script>
import FirmarFormulario from '@/views/Siniestros/FirmarFormulario.vue';
import { Select, Option } from 'element-ui';
import BaseTable from '@/components/BaseTable';
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Collapse from '@/components/Collapse/Collapse'
import CollapseItem from '@/components/Collapse/CollapseItem'
const Spanish = require("flatpickr/dist/l10n/es.js").default.es;
  export default {
    components: {
        BaseTable,
        [Select.name]: Select,
        [Option.name]: Option,
        flatPicker,
        Collapse,
        CollapseItem,
        FirmarFormulario,
    },
    data() {
      return {
        config: { dateFormat: 'd-m-Y', allowInput: true, disable: [function(date){ let ahora = new Date(); return date.getTime() > ahora.getTime() }], locale: Spanish },
        validated: false,
        showModal: false,
        model: {
            tipo_siniestro: ''
        },
        selectTipoSiniestro: [
            { label: 'Daños parciales', value: 'Daños parciales' },
            { label: 'Extravío', value: 'Extravio' },
            { label: 'Robo', value: 'Robo' },
            { label: 'Rotura', value: 'Rotura' },
        ],
        dataRegiones: [],
        comunasList: [],
        sponsor: {pais: ''},
        region: '',
        comuna: '',
        ciudad: '',
        lugar: '',
        relato: '',
        fecha: '',
        nombre_plan : '',
        estado: '',
        fecha_compra: '',
        monto_asegurado: '',
        sku_producto: '',
        numero_venta: '',
        asegurado: {
            nombre: '',
            dni: '',
            direccion: '',
            telefono: '',
            email: '',
            ciudad: '',
            celular: ''
        },
        campos_siniestro: [],
        venta_id: undefined,
        materia_asegurada: {},
        tieneFirma: false,
      }
    },
    methods: {
      reiniciarOverflow(){
        console.log(this.$refs.m0d41);
        this.$refs.m0d41.$el.classList.add('scroleable');
      },
      updateComunas(){
        this.comunasList = this.dataRegiones.find( elem => elem.region == this.region ).comunas;
      },
      async firstFormSubmit() {
        try {
          return await this.$validator.validateAll();
          //throw new Error('hno ke wea esta wea');
        } catch {
          console.log('Oh, tengo ke caputar algo');
          return false;
        }
        finally {
          
          this.validated = true;
        }
      },
      getError(name){
        return this.errors.first(name)
      },
      isValid(name) {
        return this.validated && !this.errors.has(name);
      },
      fetchCategoriasList(){
        var vm = this;
        this.axios({
            method: 'GET',
            url: 'api/test_list_categories_from_create_plan'
        }).then(response => {
            vm.selectCategorias = response.data;

        }).catch( error => {
            console.log(error);
        })
        ;
      },
      fetchData(venta_id)
      {
        var vm = this;
        this.axios({
            url: 'api/ventas_details',
            method: 'POST',
            data: {
                venta: venta_id
            }
        }).then( response => {
            vm.nombre_plan = response.data.nombre_plan;
            vm.sponsor = response.data.sponsor;
            vm.estado = response.data.estado;
            vm.fecha_compra = response.data.fecha_compra;
            vm.monto_asegurado = response.data.monto_asegurado;
            vm.sku_producto = response.data.sku_producto;
            vm.numero_venta = response.data.numero_venta;
            vm.asegurado.nombre = response.data.asegurado.nombre;
            vm.asegurado.dni = response.data.asegurado.dni;
            vm.asegurado.direccion = response.data.asegurado.direccion;
            vm.asegurado.telefono = response.data.asegurado.telefono;
            vm.asegurado.email = response.data.asegurado.email;
            vm.asegurado.ciudad = response.data.asegurado.ciudad;
            vm.asegurado.celular = response.data.asegurado.celular;
            vm.venta_id = venta_id;
            vm.materia_asegurada = response.data.materia_asegurada;
            vm.materia_asegurada.campos_siniestro.forEach( e => {
              vm.campos_siniestro.push({ nombre: e.nombre, valor: ''});
            });
            vm.selectTipoSiniestro = response.data.materia_asegurada.tipos_siniestros.map( e => ({label: e, value: e}));
            vm.tieneFirma = response.data.tieneFirma;
            vm.showModal = true; 
        }).catch( error => {
            console.log(error);
        });
      },
      sendForm(){
        var vm = this;
        this.firstFormSubmit().then( response => {
          console.log('retorno promesa de validacion', response);

          if( response ){
            vm.axios({
                method: 'POST',
                url: 'api/store_create_siniestro',
                data: {   
                        fecha_siniestro: vm.fecha,
                        tipo_siniestro: vm.model.tipo_siniestro,
                        lugar_ocurrencia: vm.lugar,
                        region: vm.region,
                        comuna: vm.comuna,
                        ciudad: vm.ciudad,
                        relato: vm.relato,
                        venta: vm.venta_id,
                        atributos: vm.campos_siniestro
                      }
            }).then( response => {
              vm.$notify({
                      message: 'Siniestro ingresado exitosamente!',
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'success'
                  });
              // Cerrar el Modal
              vm.showModal = false;
              // Emitir evento para que actualize la tabla de usuarios
              vm.$emit('successSending');
            }).catch( error => {
                
                if( error.response.status == 422){
                  Object.entries(error.response.data.errors).forEach( elem => {
                    vm.$notify({
                      message: elem[1][0],
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'danger'
                    });
                  });
                }else{
                  console.log(error);
                  if( error.response.data ){
                    vm.$notify({
                        message: error.response.data.message,
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type: 'default'
                    });
                    return;
                  }
                  vm.$notify({
                        message: 'Hubo un error, no se pudo ingresar el siniestro',
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type: 'default'
                    });
                }
            });
          }
        }).catch( reason => {
          console.log(reason);
        });
      },
    },
    mounted()
    {
        
    },
    created()
    {
        this.$parent.$on('showModalFormularioSiniestro', (venta_id) => { 
            this.venta_id = venta_id;
            this.fetchData(venta_id);

        }); 
        this.dataRegiones = require("./regiones.json");
    },
    computed: {
      
    }
  }
</script>
<style>
.scroleable{
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
